import React, { FC } from 'react'
import { Box, Space, TextBody, TextHeading } from '@ally/metronome-ui'
import LgTileGroup from './LgTileGroup'
import { AdobeTileContent } from '../../types'

const LgExploreTiles: FC<{ exploreTiles: AdobeTileContent }> = React.memo(
  ({ exploreTiles }) => {
    return exploreTiles ? (
      <Box mb="md">
        <Space mb="xs">
          <TextHeading tag="h3" size="md">
            Explore More From Ally
          </TextHeading>
        </Space>
        <TextBody tag="p" size="sm">
          We&apos;re constantly innovating, looking for new ways to deliver
          financial opportunity. From growing your wealth to achieving your
          goals, we can match you with the right solution for your needs.
        </TextBody>
        <LgTileGroup data={exploreTiles} />
      </Box>
    ) : null
  },
)

export default LgExploreTiles
